<script>
    import {
        Modal,
        BackDrop,
        Button,
        ScrollBox,
        Typography,
        CheckBox,
        Alert,
        TailSpinner,
    } from '$lib/components/UI'
    import { createEventDispatcher } from 'svelte'
    // import {ENV} from '$lib/conf'
    const dispatch = createEventDispatcher()
    export let show
    export let buttonLabel = 'Enviar solicitud'
    let aceptoTerminos
    let waiting = false
    async function onSend() {
        waiting = true
        try {
            await dispatch('send')
        } catch (_) {
            waiting = false
        }
    }
</script>

<BackDrop
    style="padding-top: 70px;position: fixed; top: 0; z-index: var(--lvl-2);"
    visible={show}
>
    <Modal
        title="Terminos y condiciones"
        subtitle="Por favor lea los terminos y condiciones de uso"
        on:clickout={(_) => {
            if (!waiting) show = false
        }}
        on:close={(_) => {
            if (!waiting) show = false
        }}
        justifyButtons="space-between"
        closeable={!waiting}
    >
        <span slot="buttonSet" class="buttonSet">
            <CheckBox
                label="He leido y acepto los terminos."
                style="justify-self:left"
                bind:checked={aceptoTerminos}
                disabled={waiting}
            />
            <Button
                size="small"
                on:click={onSend}
                disabled={!aceptoTerminos || waiting}
            >
                {#if waiting}
                    <TailSpinner size={20} />
                {/if}
                {buttonLabel}
            </Button>
            <!-- label="Enviar solicitud" -->
        </span>
        <ScrollBox width="100%" height="220px">
            <Typography type="legend">
                Términos y Condiciones – Validez y Uso de Datos
                <br /><br />
                El Usuario declara bajo juramento que toda la información y los datos ingresados en la plataforma son veraces, exactos, completos y actualizados, asumiendo plena responsabilidad por su contenido, autenticidad y legitimidad.
                <br /><br />
                El Usuario garantiza que los datos proporcionados no vulneran derechos de terceros, incluyendo pero no limitándose a derechos de propiedad intelectual, confidencialidad, protección de datos personales o cualquier otra normativa vigente.
                <br /><br />
                La carga y el uso de la información se rigen por las leyes de la República Argentina, en particular por la Ley N.º 25.326 de Protección de Datos Personales, el Código Civil y Comercial de la Nación, y demás normas aplicables.
                <br /><br />
                El Responsable de la plataforma no será responsable por errores, omisiones, inexactitudes o daños derivados del uso de datos ingresados por el Usuario, siendo este último el único responsable frente a cualquier reclamo administrativo, civil o judicial que pudiera originarse.
                <br /><br />
                Cualquier controversia derivada de estos Términos y Condiciones será sometida a la jurisdicción de los tribunales ordinarios de la República Argentina, renunciando las partes a cualquier otro fuero o jurisdicción que pudiera corresponder.
                <br /><br />
            </Typography>
        </ScrollBox>
        {#if waiting}
            <Alert type="error"
                >Por favor no cierre la pestaña del navegador.</Alert
            >
        {/if}
        <!-- <div
        style="display: flex; width: 100%; position: relative; flex-direction: row; justify-content:space-between; align-items: center"
      >
    </div> -->
    </Modal>
</BackDrop>

<style>
    .buttonSet {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 25px;
    }
</style>
